export default __webpack_public_path__ + "images/59_thumbnail.jpg";